(() => {
  const root = document.querySelector('[data-co-services-root]');
  if (!root) return;

  const launchDate = new Date(root.dataset.launchDate);
  const launched = Date.now() >= launchDate.getTime();
  const felipe = root.dataset.felipe || '';
  const andrea = root.dataset.andrea || felipe;
  const detail = root.querySelector('[data-service-detail]');
  const booking = root.querySelector('[data-service-booking]');
  const serviceInput = root.querySelector('[data-service-input]');
  const minDateInput = root.querySelector('[data-service-date]');

  const services = {
    diagnostico: {
      name: 'Diagnóstico', kicker: 'DIAGNÓSTICO', icon: 'scan-search',
      title: 'Encontramos primero qué está pasando.',
      points: ['Revisión orientada al síntoma.','Te explicamos qué requiere atención.','Si requiere una pieza, validamos compatibilidad antes.'],
      before: 'Antes del 5 de octubre puedes contarnos el problema y Felipe te orienta por WhatsApp.',
      advisor: 'Felipe', number: felipe,
      msg: 'Hola Felipe, quiero consultar un problema de mi bicicleta antes de agendar diagnóstico.'
    },
    di2: {
      name: 'Diagnóstico Di2 + informe técnico', kicker: 'DIAGNÓSTICO DI2', icon: 'cpu',
      title: 'Revisamos el sistema y documentamos los hallazgos.',
      points: ['Revisión del sistema Di2 y del síntoma reportado.','Informe técnico con hallazgos y recomendaciones.','Compatibilidad antes de sugerir cambios.'],
      before: 'Si hoy tienes una falla Di2, Felipe puede orientarte y decirte qué información preparar para el diagnóstico.',
      advisor: 'Felipe', number: felipe,
      msg: 'Hola Felipe, tengo una consulta sobre Shimano Di2 y quiero preparar un diagnóstico con informe técnico.'
    },
    instalacion: {
      name: 'Instalación de componente', kicker: 'INSTALACIÓN', icon: 'package-plus',
      title: 'Primero confirmamos que la pieza sí corresponde.',
      points: ['Validación de referencia antes de instalar.','Revisión de compatibilidad con tu bicicleta.','Coordinación del trabajo desde el 5 de octubre.'],
      before: 'Andrea puede ayudarte hoy con disponibilidad y coordinación; Felipe valida compatibilidad cuando lo necesites.',
      advisor: 'Andrea', number: andrea,
      msg: 'Hola Andrea, quiero consultar una instalación de componente y validar cómo prepararla para el taller.'
    },
    mantenimiento: {
      name: 'Mantenimiento', kicker: 'MANTENIMIENTO', icon: 'wrench',
      title: 'Revisamos lo necesario para que vuelvas a rodar tranquilo.',
      points: ['Revisión y ajustes según el estado de la bicicleta.','Atención a transmisión, frenos y puntos relevantes.','Recomendaciones claras sin cambiar piezas por cambiar.'],
      before: 'Puedes contarle hoy a Andrea qué mantenimiento buscas y ella te orienta sobre la apertura y coordinación.',
      advisor: 'Andrea', number: andrea,
      msg: 'Hola Andrea, quiero consultar mantenimiento para mi bicicleta y saber cómo coordinarlo desde la apertura del taller.'
    }
  };

  const enc = (v) => encodeURIComponent(v);
  const wa = (number, msg) => `https://wa.me/${String(number).replace(/\D/g,'')}?text=${enc(msg)}`;

  if (launched) root.classList.add('is-launched');
  if (minDateInput) minDateInput.min = '2026-10-05';

  const update = (key) => {
    const s = services[key] || services.diagnostico;
    root.querySelectorAll('[data-service]').forEach(btn => {
      const active = btn.dataset.service === key;
      btn.classList.toggle('is-selected', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      const badge = btn.querySelector('.co-svc-card__body small');
      if (badge) badge.textContent = launched ? 'DISPONIBLE' : 'DESDE 5 OCT';
    });

    const icon = detail.querySelector('.co-svc__detail-icon');
    if (icon) icon.innerHTML = `<i data-lucide="${s.icon}" aria-hidden="true"></i>`;
    detail.querySelector('[data-service-kicker]').textContent = s.kicker;
    detail.querySelector('[data-service-title]').textContent = s.title;
    detail.querySelector('[data-service-availability]').textContent = launched ? 'Disponible' : 'Disponible desde 5 OCT';
    detail.querySelector('[data-service-copy]').textContent = launched ? 'Selecciona el servicio y envíanos tu solicitud. Confirmamos fecha y disponibilidad contigo por WhatsApp.' : s.before;
    const points = detail.querySelector('[data-service-points]');
    points.innerHTML = s.points.map(p => `<span><i data-lucide="check" aria-hidden="true"></i>${p}</span>`).join('');
    const action = detail.querySelector('[data-service-action]');
    if (launched) {
      action.textContent = 'Solicitar servicio';
      action.removeAttribute('target');
      action.removeAttribute('rel');
      action.href = '#solicitud-servicio';
    } else {
      action.textContent = `Consultar con ${s.advisor}`;
      action.target = '_blank';
      action.rel = 'noopener';
      action.href = wa(s.number, s.msg);
    }
    if (serviceInput) serviceInput.value = s.name;
    if (window.lucide) window.lucide.createIcons();
  };

  root.addEventListener('click', (e) => {
    const card = e.target.closest('[data-service]');
    if (card) {
      update(card.dataset.service);
      if (window.innerWidth < 768) detail.scrollIntoView({behavior:'smooth', block:'nearest'});
    }
    const action = e.target.closest('[data-service-action]');
    if (action && launched) {
      e.preventDefault();
      booking.hidden = false;
      booking.scrollIntoView({behavior:'smooth', block:'start'});
      window.CycloOutletTrack?.('workshop_booking_start', {service: serviceInput?.value || ''});
    }
    if (e.target.closest('[data-service-booking-close]')) booking.hidden = true;
  });

  root.querySelector('[data-service-form]')?.addEventListener('submit', (e) => {
    e.preventDefault();
    if (!launched) return;
    const form = new FormData(e.currentTarget);
    const service = form.get('service') || '';
    const target = /Di2|Diagnóstico/i.test(service) ? felipe : andrea;
    const msg = [
      'Hola CycloOutlet, quiero solicitar un servicio.',
      '', `Servicio: ${service}`,
      `Nombre: ${form.get('name') || ''}`,
      `WhatsApp: ${form.get('phone') || ''}`,
      `Bicicleta: ${form.get('bike') || 'Por confirmar'}`,
      `Fecha solicitada: ${form.get('date') || 'Por confirmar'}`,
      `Qué sucede: ${form.get('problem') || ''}`
    ].join('\n');
    window.CycloOutletTrack?.('workshop_booking_complete', {service});
    window.open(wa(target, msg), '_blank', 'noopener');
  });

  root.querySelectorAll('[data-co-advisor]').forEach(link => {
    link.addEventListener('click', () => window.CycloOutletTrack?.('whatsapp_service_click', {advisor: link.dataset.coAdvisor || ''}));
  });

  update('diagnostico');
})();